import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import Text from '../../../Text'
import { QA_NAME_DELETE_CHECKLIST_BUTTON } from '../RequestProfileTabInternalTasks.constants'
import { useRequestProfileTabInternalTasksContext } from '../RequestProfileTabInternalTasks.hooks'

import * as styles from './RequestProfileTabInternalTasksChecklistHeader.module.css'

import DeleteIcon from '../../../../icons/delete.svg'

function RequestProfileTabInternalTasksChecklistHeader({
  name,
  progress,
  onDelete,
}) {
  const { t } = useTranslation()

  const { canEdit } = useRequestProfileTabInternalTasksContext()

  return (
    <div className={styles.RequestProfileTabInternalTasksChecklistHeader}>
      <Text className={styles.name}>{name}</Text>
      <div className={styles.actions}>
        <Text isSecondary>{`${progress} %`}</Text>
        {canEdit ? (
          <Button.Icon
            isGrey
            Icon={DeleteIcon}
            qaName={QA_NAME_DELETE_CHECKLIST_BUTTON}
            tooltip={t('RequestProfile.InternalTasksDeleteListTooltipKey')}
            onClick={onDelete}
          />
        ) : null}
      </div>
    </div>
  )
}

export default RequestProfileTabInternalTasksChecklistHeader
